import React, { useMemo } from 'react'
import { CalendarSelection, Day } from '../../../../types/calendar.types'

type WeeklyCalendarProps = {
  selection: CalendarSelection
  onSelectionChange: (selection: CalendarSelection) => void
  availableWeeklyDays: Day[]
}

export const WeeklyCalendar: React.FC<WeeklyCalendarProps> = ({
  selection,
  onSelectionChange,
  availableWeeklyDays = []
}) => {
  // Generate default weekly days if none provided
  const generateWeeklyDays = () => {
    const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    return weekDays.map((dayName, index) => ({
      day: index + 1,
      isEnabled: availableWeeklyDays.some((day) => day.day === index + 1),
      isSelected: index + 1 === selection.value
    }))
  }

  const calendarDays = useMemo(() => generateWeeklyDays(), [selection, availableWeeklyDays])

  const getWeekDayName = (dayIndex: number): string => {
    const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    return weekDays[dayIndex - 1] || ''
  }

  const handleDaySelect = (day: number) => {
    onSelectionChange({
      ...selection,
      value: day
    })
  }

  return (
    <div className=''>
      {/* Calendar Grid */}
      <div className='flex flex-wrap gap-3 w-full'>
        {calendarDays.map(({ day, isEnabled, isSelected }) => {
          const getButtonClasses = () => {
            const baseClasses =
              'flex-1 h-14 rounded-lg flex items-center justify-center text-[14px] font-[500] transition-all duration-200 border min-w-[120px]'

            if (isSelected) {
              return `${baseClasses} bg-[#232323] text-white border-[#232323]`
            }

            if (isEnabled) {
              return `${baseClasses} bg-white text-[#232323] border-[#E5E7EB] hover:border-[#232323] hover:scale-105`
            }

            return `${baseClasses} bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed border-[#E5E7EB]`
          }

          return (
            <button key={day} onClick={() => handleDaySelect(day)} disabled={!isEnabled} className={getButtonClasses()}>
              {getWeekDayName(day)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
